module.exports = __webpack_public_path__ + "static/media/sunyiwen_match_04.e5e62deb.png";